export default "__VITE_ASSET__BwjhwLyA__"